import { ArchiveSettingsOutlineIcon } from './ArchiveSettingsOutlineIcon';

/**
 * author: Colton Wiscombe
 * id E07DE8F7-F3D7-4FCB-95EC-5D6C52CAFE32
 * name archive-settings-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-settings-outline.svg
 * tags
 * - Settings 
 */
export const BoxSettingsOutlineIcon = ArchiveSettingsOutlineIcon;
export default BoxSettingsOutlineIcon